import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { BlockThirdParty, Iframe, transformLinkUri } from "gatsby-theme-gba"

const IframeEditable = ({ blok }) => {
  const backgroundImage = "/block-3rd-party-placeholder.jpg"

  const iframeElement = (
    <Iframe
      title={blok.title}
      src={blok.src}
      width={blok.width}
      height={blok.height}
    />
  )

  if (blok.block3rdParty !== "true") {
    return (
      <div {...storyblokEditable(blok)} key={blok._uid}>
        {iframeElement}
      </div>
    )
  }

  let link = ""
  if (blok.infoUrl) {
    link = blok.infoUrl.id
      ? transformLinkUri(blok.infoUrl.id, "", blok.currentLanguage)
      : blok.infoUrl.cached_url
  }

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <BlockThirdParty
        cookieKey={blok.cookieKey}
        backgroundUrl={backgroundImage}
        buttonText={blok.buttonText}
        buttonPermanentText={blok.buttonPermanentText}
        infoText={blok.infoText}
        infoUrl={link}
        infoUrlText={blok.infoUrlText}
      >
        {iframeElement}
      </BlockThirdParty>
    </div>
  )
}

export default IframeEditable
